import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons";

import { ConditionIcon, GalleryButton, Expandable } from "../../../../../components";
import { Responsive, DesktopOnly, MobileOnly } from "../../../../../layout";
import { round2, getItemName, QUESTION_RESULT_STATUS, getImageAndVideoFileTypes, getInterventionPriceWithVAT } from "../../../../../util/common";

import "./index.scss";

class NotFixedItems extends Component {
  renderRow = (item, id, description, price, images, videos, status, profile) => {
    return (
      <Grid.Row key={id} className="not-fixed-row">
        <Grid.Column computer={5} widescreen={6} mobile={16}>
          <div className="interventions-row-title">
            <ConditionIcon status={status || 3} className="not-fixed-status-icon" />

            <Expandable className="not-fixed-title" text={getItemName(this.props.t, item)} />
          </div>
        </Grid.Column>

        <Grid.Column computer={5} widescreen={6} mobile={16} className="not-fixed-description">
          {profile > 0 && <Expandable text={profile + "mm"} />}

          <Expandable text={description} />
        </Grid.Column>

        {price && (
          <MobileOnly>
            <Grid.Column width={6}>{price}</Grid.Column>
          </MobileOnly>
        )}
        <DesktopOnly>
          <Grid.Column width={3} className="interventions-price">
            {price}
          </Grid.Column>
        </DesktopOnly>

        <Grid.Column computer={1} mobile={4}>
          <GalleryButton images={images} videos={videos} />
        </Grid.Column>
      </Grid.Row>
    );
  };

  renderInterventionPrice = intervention => {
    const { include_vat } = this.props.settings;

    if (!(intervention.price > 0.01)) return null;

    const price = include_vat ? getInterventionPriceWithVAT(intervention, this.props.settings) : intervention.price;

    return <span className="not-fixed-price">€ {round2(price).toFixed(2)}</span>;
  };

  renderNotFixedItems = interventions => {
    if (!Array.isArray(interventions)) return null;

    return interventions.map(i => {
      const { images, videos } = getImageAndVideoFileTypes(i.attachments);

      return this.renderRow(i, i.id, i.description, this.renderInterventionPrice(i), images, videos, i.question_result_status);
    });
  };

  renderNotFixedCheckItems = checkItems => {
    if (!Array.isArray(checkItems)) return null;

    return checkItems.map(item => this.renderRow(item, "check_" + item.id, item.raw, null, item.images, item.videos, item.status, item.tyre_profile));
  };

  render() {
    const { notFixedItems, notFixedCheckItems = [], showMobile, t } = this.props;

    if (notFixedItems.length + notFixedCheckItems.length < 1) return null;

    return (
      <Responsive showMobile={showMobile}>
        <Grid verticalAlign="middle" className="repair-overview-v2 not-fixed-container component-container">
          <Grid.Row className="not-fixed-heading">
            <Grid.Column width={16}>
              <FontAwesomeIcon icon={faTimesCircle} className="not-fixed-heading-icon" />
              <h4 className="not-fixed-heading-title">{t("cc_items_not_fixed").message || "Items not fixed"}</h4>
            </Grid.Column>
          </Grid.Row>
          {this.renderNotFixedItems(notFixedItems)}
          {this.renderNotFixedCheckItems(notFixedCheckItems)}
        </Grid>
      </Responsive>
    );
  }
}

const TranslatedNotFixedItems = withTranslation()(NotFixedItems);

TranslatedNotFixedItems.filterNotFixedItems = interventions =>
  interventions.filter(r => {
    if (!r.question_result_id) return !r.mechanic_fixed;

    return (r.question_result_status === QUESTION_RESULT_STATUS.ADVISED || r.question_result_status === QUESTION_RESULT_STATUS.NECESSARY) && !r.mechanic_fixed;
  });

TranslatedNotFixedItems.filterNotFixedCheckItems = (checkItems, interventions) =>
  checkItems
    .filter(
      item =>
        (item.status === QUESTION_RESULT_STATUS.ADVISED || item.status === QUESTION_RESULT_STATUS.NECESSARY) &&
        !item.mechanic_fixed &&
        !interventions.some(i => i.question_result_id === item.id)
    )
    .sort((a, b) => b.status - a.status);

export default TranslatedNotFixedItems;
